/* Lens builder: full-page step flow for frames and contact lenses.
 * Data comes from <script data-lens-builder-data> in sections/main-lens-builder.liquid.
 * Frames:  Usage > Prescription > Lens type > Lenses > Review.
 *          Adds 2 cart lines (frame + lens package variant) linked by _lens_set.
 * Contact: Power > Review. Adds 1 line with the eye power as line-item properties.
 * A prescription photo is sent as a file line-item property (multipart), which
 * Shopify stores and links on the order. */
(function () {
  'use strict';

  var root = document.querySelector('[data-lens-builder]');
  var dataEl = document.querySelector('[data-lens-builder-data]');
  if (!root || !dataEl) return;

  var D = JSON.parse(dataEl.textContent);
  var host = root.querySelector('[data-lb-steps]');
  var stepper = root.querySelector('[data-lb-stepper]');
  var viewport = root.querySelector('.lb__viewport');
  var panel = root.querySelector('.lb__panel');
  var nextBtn = root.querySelector('[data-lb-next]');
  var nextLabel = root.querySelector('[data-lb-next-label]');
  var prevBtn = root.querySelector('[data-lb-prev]');
  var errorEl = root.querySelector('[data-lb-error]');
  var breakdownEl = root.querySelector('[data-lb-breakdown]');
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (D.moneyFormat || 'Rs.{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  }
  function shortMoney(cents) { return 'Rs ' + Math.round(cents / 100).toLocaleString('en-US'); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function range(from, to, step, digits, signed) {
    var out = [];
    var n = Math.round((to - from) / step);
    for (var i = 0; i <= n; i++) {
      var v = from + i * step;
      var s = Math.abs(v) < 1e-9 ? (0).toFixed(digits) : v.toFixed(digits);
      if (signed && v > 1e-9) s = '+' + s;
      out.push(s);
    }
    return out;
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ---------- icons (inline, stroke = currentColor) ----------
   * Lens diagrams share one lens outline (front view). Flat top = D-segment
   * (straight top edge), round top = full round segment, progressive = narrow
   * corridor with shaded blur zones at the lower sides and no line. */
  var I = {
    distance: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><path d="M6.8 14.6l3.2-4 2.2 2.4 2.2-3 3 4.6"/>',
    reading: '<path d="M4 6.5c2.7-1 5.3-1 8 .8 2.7-1.8 5.3-1.8 8-.8V18c-2.7-1-5.3-1-8 .8-2.7-1.8-5.3-1.8-8-.8z"/><path d="M12 7.3V18.8"/>',
    multifocal: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><path d="M4.2 13.6c2.5.8 5.1 1.2 7.8 1.2s5.3-.4 7.8-1.2" stroke-dasharray="1.4 1.6"/><path d="M4.2 13.6c2.5.8 5.1 1.2 7.8 1.2s5.3-.4 7.8-1.2c-.7 3-3.2 5.4-6.2 5.4h-3.2c-3 0-5.5-2.4-6.2-5.4z" fill="currentColor" fill-opacity=".16" stroke="none"/>',
    progressive: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><path d="M4.6 10.6c3 .5 4.8 1.6 5.6 3.3.6 1.3.4 2.8-.4 4.1M19.4 10.6c-3 .5-4.8 1.6-5.6 3.3-.6 1.3-.4 2.8.4 4.1"/><path d="M4 12.2c2.6.6 4.5 1.8 5.4 3.5l-.6 2.4C6.3 17.1 4.4 15 4 12.6zM20 12.2c-2.6.6-4.5 1.8-5.4 3.5l.6 2.4c2.5-1 4.4-3.1 4.8-5.5z" fill="currentColor" fill-opacity=".25" stroke="none"/>',
    bifocal: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><path d="M8.8 12.4h6.4A3.5 3.5 0 1 1 8.8 12.4Z" fill="currentColor" fill-opacity=".16"/>',
    roundtop: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><circle cx="12" cy="14.3" r="3" fill="currentColor" fill-opacity=".16"/>',
    flattop: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><path d="M8.8 12.4h6.4A3.5 3.5 0 1 1 8.8 12.4Z" fill="currentColor" fill-opacity=".16"/>',
    near: '<path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6S2 12 2 12z"/><circle cx="12" cy="12" r="2.5"/>',
    zero: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><ellipse cx="12" cy="11.8" rx="2" ry="2.8"/>',
    frame: '<circle cx="6.5" cy="13" r="3.5"/><circle cx="17.5" cy="13" r="3.5"/><path d="M10 13c1.2-1 2.8-1 4 0M3 13l-1-4M21 13l1-4"/>',
    clear: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><path d="M7.2 10.2l2.6-2.6M8 13.4l5-5"/>',
    blue: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><rect x="8.2" y="8.4" width="7.6" height="5.2" rx=".8"/><path d="M10.6 15.8h2.8M12 13.6v2.2"/>',
    transition: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><path d="M12 5h4.3C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4H12z" fill="currentColor" fill-opacity=".38" stroke="none"/><circle cx="20.6" cy="3" r="1.3"/>',
    tint: '<path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z"/><path d="M4 8.4C4 6.4 5.5 5 7.7 5h8.6C18.5 5 20 6.4 20 8.4v4.2c0 3.6-2.8 6.4-6.4 6.4h-3.2C6.8 19 4 16.2 4 12.6z" fill="currentColor" fill-opacity=".3" stroke="none"/>',
    driving: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="2"/><path d="M4.5 10.5h5M14.5 10.5h5M12 14v6"/>',
    pencil: '<path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/>',
    clock: '<circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/>',
    upload: '<path d="M12 15V4M7.5 8.5L12 4l4.5 4.5"/><path d="M4 15v3.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V15"/>',
    doc: '<path d="M7 3h7l4 4v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/><path d="M14 3v4h4M9 13h6M9 17h6"/>',
    none: '<path d="M4 14c0-5 3.6-9 8-9s8 4 8 9"/><path d="M4 14c2.5 2 13.5 2 16 0"/><path d="M6 19L18 7"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>',
    check: '<path d="M5 12.5l4.2 4.2L19 7"/>',
    chat: '<path d="M4 19.5l1.2-3.6A7.5 7.5 0 1 1 8.1 18.8z"/><path d="M9 10.5c.3 1.9 2.3 3.8 4.4 4.1l1.2-1.2-1.8-.9-.7.7c-.8-.4-1.4-1-1.8-1.8l.7-.7-.9-1.8z" stroke-width="1.2"/>',
  };
  // Card photos (assets/lens-photo-*.jpg, scripts/build-lens-photos.py); SVG is the fallback.
  // Lens types under Progressive have their own photos with the progressive zones ("clear_pr").
  function photoKey(name) {
    var imgs = D.iconImages || {};
    return S.usage === 'progressive' && imgs[name + '_pr'] ? name + '_pr' : name;
  }
  // dark photo of a transition card in the chosen transition colour
  function darkPhoto(k, large) {
    var map = S.trnColour === 'Brown' ? (large ? D.iconImagesDarkBrownLg : D.iconImagesDarkBrown) : (large ? D.iconImagesDarkLg : D.iconImagesDark);
    return (map && map[k]) || '';
  }
  function cardIcon(name) {
    var k = photoKey(name);
    var src = D.iconImages && D.iconImages[k];
    if (!src) return icon(name);
    var dark = darkPhoto(k);
    return '<img class="lb__icon-img" src="' + esc(src) + '" alt="" loading="lazy" decoding="async">' +
      (dark ? '<img class="lb__icon-img lb__photo-dark" data-dark-key="' + esc(k) + '" src="' + esc(dark) + '" alt="" loading="lazy" decoding="async">' : '');
  }
  function icon(name, cls) {
    return '<svg class="' + (cls || 'lb__icon') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (I[name] || I.clear) + '</svg>';
  }

  /* ---------- usages (step 1) ---------- */
  var USAGES = {
    distance: { label: 'Distance', icon: 'distance', rx: true, add: false, desc: 'Single vision lenses for seeing far away.', info: 'For everyday use, driving, TV and walking. Choose this when your prescription has no ADD value.' },
    reading: { label: 'Reading', icon: 'reading', rx: true, add: false, desc: 'Single vision lenses for seeing up close.', info: 'For books, phone and close work. You can enter your full prescription or only your reading power.' },
    progressive: { label: 'Progressive', icon: 'progressive', rx: true, add: true, multi: true, desc: 'Near, middle and far in one lens, no visible line.', info: 'One lens for all distances. Your prescription needs an ADD value.' },
    bifocal: { label: 'Bifocal', icon: 'bifocal', rx: true, add: true, multi: true, desc: 'Far and near zones divided by a visible line.', info: 'Two zones in one lens; the lower part is for reading. Your prescription needs an ADD value.' },
    zero: { label: 'Zero Power', icon: 'zero', rx: false, add: false, desc: 'No eyesight power: screen use, style or driving.', info: 'Lenses without any prescription.' },
  };
  var USAGE_ORDER = ['distance', 'reading', '__multi', 'zero'];

  /* ---------- catalog ---------- */
  var variantByKey = {};
  (D.lensVariants || []).forEach(function (v) { variantByKey[v.key] = v; });
  // High-cylinder copies of each Distance lens variant (same title + suffix), see cylFactor().
  var CYL_SUFFIX = { 1.5: ' (CYL above 2.50)', 2: ' (CYL above 4.00)' };
  var LENSES = [];
  function lines(list) { return (list || []).map(function (s) { return String(s).trim(); }).filter(Boolean); }
  (D.lenses || []).forEach(function (l) {
    // A colour group lists its variants as "Variant title | #swatch | Label", one per line.
    var members = lines(l.members).map(function (row) {
      var p = row.split('|').map(function (s) { return s.trim(); });
      return { key: p[0], swatch: p[1] || '', label: p[2] || '' };
    });
    if (!members.length) members = [{ key: l.variant, swatch: l.swatch || '', label: '' }];
    members.forEach(function (m) {
      var v = variantByKey[m.key];
      if (!v) return;
      LENSES.push({
        idx: LENSES.length,
        key: m.key,
        name: m.label || v.name || m.key,
        variant: v,
        usages: (l.usages || []).filter(Boolean),
        category: l.category,
        info: l.info || '',
        includes: lines(l.includes),
        group: (l.group || '').trim(),
        swatch: m.swatch,
        strength: !!l.strength,
        rule: l.rule || '',
        iconKey: l.icon || '',
        maxPower: parseFloat(l.maxPower) || 0,
      });
    });
  });
  var CATS = (D.categories || []).filter(function (c) { return c.key; }).map(function (c) {
    // "usage: Name" lines rename a lens type for one usage, e.g. "zero: Blue Filter Lens"
    var names = {};
    lines(c.usageNames).forEach(function (row) {
      var i = row.indexOf(':');
      if (i > 0) names[row.slice(0, i).trim()] = row.slice(i + 1).trim();
    });
    c.names = names;
    return c;
  });
  function catName(c, usage) { return (c.names && c.names[usage || S.usage]) || c.name; }
  function catIcon(key) {
    var c = CATS.filter(function (x) { return x.key === key; })[0];
    return (c && c.icon) || key;
  }
  var STRENGTHS = [['Dark', '80%'], ['Medium', '50%'], ['Light', '20%']];

  /* ---------- value lists ---------- */
  var SPH_GLASSES = range(-12, 10, 0.25, 2, true);
  var CYL_GLASSES = range(-6, 6, 0.25, 2, true);
  var AXIS_GLASSES = range(1, 180, 1, 0, false);
  var ADD_VALUES = range(0.75, 3.5, 0.25, 2, true);
  var READER_VALUES = range(0.75, 3.5, 0.25, 2, true);
  var PD_SINGLE = range(46, 80, 1, 0, false);
  var PD_DUAL = range(20, 40, 0.5, 1, false);
  var SPH_CONTACT = range(-10, 8, 0.25, 2, true);
  var CYL_CONTACT = ['-0.75', '-1.25', '-1.75', '-2.25'];
  var AXIS_CONTACT = range(10, 180, 10, 0, false);

  /* ---------- state ---------- */
  var S = {
    step: 0,
    usage: null, // distance | reading | progressive | bifocal | zero | __frame_only
    multiOpen: false,
    category: null,
    lens: null, // LENSES entry
    strength: 'Dark',
    trnColour: 'Gray', // transition lenses: Gray | Brown, one choice for every transition card
    rxMethod: null, // upload | enter | reader | later | none (contacts)
    rx: { r: { sph: '', cyl: '', axis: '' }, l: { sph: '', cyl: '', axis: '' }, add: '', reader: '', pdMode: '', pd: '', pdR: '', pdL: '', same: false },
    file: null,
    filePreview: '',
    showErrors: false,
    busy: false,
  };
  function U() { return USAGES[S.usage] || null; }
  function needsRx() { return D.mode === 'contact' || !!(U() && U().rx); }
  function needsAdd() { return !!(U() && U().add); }
  function toric() { return D.mode === 'contact' ? !!D.isToric : true; }
  function sendsFile() { return !!S.file && (S.rxMethod === 'upload' || S.rxMethod === 'enter') && needsRx(); }

  function lensesFor(usage, cat) {
    return LENSES.filter(function (l) { return l.usages.indexOf(usage) > -1 && (!cat || l.category === cat) && !lensHidden(l); });
  }

  // SPH values typed in by the customer, [] when the power is not known (photo, send later).
  function enteredSph() {
    if (S.rxMethod !== 'enter') return [];
    return ['r', 'l'].filter(function (k) { return S.rx[k].sph !== ''; }).map(function (k) { return parseFloat(S.rx[k].sph) || 0; });
  }
  function powerKnown() { return enteredSph().length === 2; }
  // Ultra Thin rules (Distance): SPH -3.00 to -12.00 shows 1.67 and 1.74; SPH +3.00 and above
  // shows only 1.67; anything weaker hides both. Unknown power shows both with a price note.
  function lensHidden(l) {
    if (!l.rule || !powerKnown()) return false;
    var sph = enteredSph();
    var minus = sph.some(function (v) { return v <= -3; });
    var plus = sph.some(function (v) { return v >= 3; });
    if (l.rule === 'ut174') return !minus;
    if (l.rule === 'ut167') return !(minus || plus);
    return false;
  }
  // Distance lenses cost 1.5x when CYL is above ±2.50 and 2x above ±4.00 (either eye).
  function maxCyl() {
    if (S.rxMethod !== 'enter') return 0;
    return Math.max(Math.abs(parseFloat(S.rx.r.cyl) || 0), Math.abs(parseFloat(S.rx.l.cyl) || 0));
  }
  function cylFactor() {
    if (S.usage !== 'distance') return 1;
    var c = maxCyl();
    return c > 4 ? 2 : c > 2.5 ? 1.5 : 1;
  }
  function effVariant(l) {
    var f = cylFactor();
    return (f > 1 && variantByKey[l.key + CYL_SUFFIX[f]]) || l.variant;
  }
  function catsFor(usage) {
    return CATS.filter(function (c) { return lensesFor(usage, c.key).length; });
  }

  // Strongest meridian power entered (|SPH| or |SPH + CYL|), 0 if unknown.
  function maxPower() {
    if (S.rxMethod === 'reader') return Math.abs(parseFloat(S.rx.reader) || 0);
    if (S.rxMethod !== 'enter') return 0;
    var m = 0;
    ['r', 'l'].forEach(function (k) {
      var sph = parseFloat(S.rx[k].sph) || 0;
      var cyl = parseFloat(S.rx[k].cyl) || 0;
      m = Math.max(m, Math.abs(sph), Math.abs(sph + cyl));
    });
    return m;
  }
  function isPlanoRx() {
    if (S.rxMethod !== 'enter' || !S.rx.r.sph || !S.rx.l.sph) return false;
    return ['r', 'l'].every(function (k) { return parseFloat(S.rx[k].sph) === 0 && (!S.rx[k].cyl || parseFloat(S.rx[k].cyl) === 0); });
  }
  function bigDifference() {
    if (S.rxMethod !== 'enter' || !S.rx.r.sph || !S.rx.l.sph) return false;
    return Math.abs(parseFloat(S.rx.r.sph) - parseFloat(S.rx.l.sph)) > 3;
  }
  function lensBlocked(l) { return !!l.maxPower && maxPower() > l.maxPower; }

  /* ---------- steps ---------- */
  function steps() {
    if (D.mode === 'contact') return [{ key: 'power', label: 'Power' }, { key: 'review', label: 'Review' }];
    var list = [{ key: 'usage', label: 'Usage' }];
    if (S.usage === '__frame_only') return list.concat([{ key: 'review', label: 'Review' }]);
    if (!S.usage || needsRx()) list.push({ key: 'rx', label: 'Prescription' });
    if (!S.usage || catsFor(S.usage).length > 1) list.push({ key: 'category', label: 'Lens Type' });
    // a lens type with only one lens (e.g. Drive Safe) is chosen directly, without a Lenses step
    if (!onlyLens()) list.push({ key: 'lens', label: 'Lenses' });
    list.push({ key: 'review', label: 'Review' });
    return list;
  }
  function current() { return steps()[S.step]; }
  function onlyLens() {
    if (!S.usage || !S.category) return null;
    var list = lensesFor(S.usage, S.category);
    // a single transition lens still gets the Lenses step, for its Gray / Brown choice
    return list.length === 1 && !isTrn(list[0]) ? list[0] : null;
  }
  function pickOnlyLens() { var l = onlyLens(); if (l) S.lens = l; }

  /* ---------- validation ---------- */
  function pdErrors() {
    var e = [];
    if (D.mode !== 'frame') return e;
    if (!S.rx.pdMode) e.push({ field: 'pdMode', msg: 'PD option' });
    if (S.rx.pdMode === 'single' && !S.rx.pd) e.push({ field: 'pd', msg: 'PD' });
    if (S.rx.pdMode === 'dual') {
      if (!S.rx.pdR) e.push({ field: 'pdR', msg: 'Right PD' });
      if (!S.rx.pdL) e.push({ field: 'pdL', msg: 'Left PD' });
    }
    return e;
  }
  function rxErrors() {
    if (!S.rxMethod) return [{ field: 'method', msg: 'Choose how you want to add your prescription.' }];
    if (S.rxMethod === 'upload') return (S.file ? [] : [{ field: 'file', msg: 'Prescription photo' }]).concat(pdErrors());
    if (S.rxMethod === 'reader') return (S.rx.reader ? [] : [{ field: 'reader', msg: 'Reading power' }]).concat(pdErrors());
    if (S.rxMethod !== 'enter') return [];
    var e = [];
    var eyes = [['r', 'Right eye']];
    if (!(D.mode === 'contact' && S.rx.same)) eyes.push(['l', 'Left eye']);
    eyes.forEach(function (p) {
      var eye = S.rx[p[0]];
      if (!eye.sph) e.push({ field: 'sph-' + p[0], msg: p[1] + ': SPH' });
      if (toric()) {
        if (D.mode === 'contact' && !eye.cyl) e.push({ field: 'cyl-' + p[0], msg: p[1] + ': CYL' });
        if (eye.cyl && eye.cyl !== '0.00' && !eye.axis) e.push({ field: 'axis-' + p[0], msg: p[1] + ': Axis' });
      }
    });
    if (D.mode === 'frame' && needsAdd() && !S.rx.add) e.push({ field: 'add', msg: 'ADD' });
    return e.concat(pdErrors());
  }
  function stepValid(key) {
    if (key === 'usage') return !!S.usage;
    if (key === 'rx' || key === 'power') return rxErrors().length === 0;
    if (key === 'category') return !!S.category;
    if (key === 'lens') return !!S.lens && !lensBlocked(S.lens) && !lensHidden(S.lens);
    if (key === 'review') return !!D.variant.available;
    return false;
  }

  /* ---------- subtotal (only in the bottom bar) ---------- */
  function lensPrice() { return S.lens && S.usage !== '__frame_only' ? effVariant(S.lens).price : 0; }
  function updateTotals() {
    var total = D.variant.price + lensPrice();
    root.querySelectorAll('[data-lb-total]').forEach(function (el) {
      var t = money(total);
      if (el.textContent !== t) {
        el.textContent = t;
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      }
    });
    if (breakdownEl) {
      // breakdown only once a lens is chosen; before that the subtotal is the frame price
      breakdownEl.textContent = D.mode === 'frame' && S.lens && S.usage !== '__frame_only'
        ? 'Frame ' + shortMoney(D.variant.price) + ' + Lenses ' + (lensPrice() ? shortMoney(lensPrice()) : 'free')
        : '';
    }
  }

  /* ---------- stepper + nav ---------- */
  function renderStepper() {
    var list = steps();
    stepper.innerHTML = '<ol class="lb__stepper-list">' + list.map(function (s, i) {
      var state = i < S.step ? 'is-done' : i === S.step ? 'is-current' : 'is-todo';
      return '<li class="lb__stepper-item ' + state + '"><button type="button" data-goto="' + i + '"' + (i < S.step ? '' : ' disabled') + (i === S.step ? ' aria-current="step"' : '') + '>' +
        '<span class="lb__stepper-dot">' + (i < S.step ? icon('check', 'lb__stepper-check') : i + 1) + '</span>' +
        '<span class="lb__stepper-label">' + esc(s.label) + '</span></button></li>';
    }).join('') + '</ol>';
  }
  function updateNav() {
    var key = current().key;
    prevBtn.hidden = S.step === 0;
    nextLabel.textContent = key === 'review' ? (D.variant.available ? 'Add to cart' : 'Sold out') : 'Continue';
    nextBtn.disabled = key === 'review' && !D.variant.available;
    nextBtn.classList.toggle('is-muted', !stepValid(key));
  }

  /* ---------- views ---------- */
  function head(title, sub) {
    return '<header class="lb__head"><h2 class="lb__step-title">' + esc(title) + '</h2>' + (sub ? '<p class="lb__step-sub">' + esc(sub) + '</p>' : '') + '</header>' +
      (D.variant.available ? '' : '<div class="lb__info lb__soldout">' + icon('info') + '<p><strong>This item is sold out.</strong> Lenses can\'t be added to it right now. ' +
        '<a href="' + esc(D.product.url) + '">Back to product</a></p></div>');
  }
  function infoBlock(text, includes) {
    if (!text && !(includes && includes.length)) return '';
    return '<span class="lb__more" hidden>' + (text ? '<span class="lb__more-text">' + esc(text) + '</span>' : '') +
      (includes && includes.length ? '<span class="lb__chips">' + includes.map(function (x) { return '<span class="lb__chip-tag">' + icon('check', 'lb__chip-check') + esc(x) + '</span>'; }).join('') + '</span>' : '') + '</span>';
  }
  function card(o) {
    var hasInfo = !!(o.info || (o.includes && o.includes.length));
    var big = o.icon && D.iconImagesLg && D.iconImagesLg[photoKey(o.icon)];
    var bigDark = big && darkPhoto(photoKey(o.icon), true);
    return '<div class="lb__card' + (o.selected ? ' is-selected' : '') + (o.muted ? ' lb__card--muted' : '') + (o.disabled ? ' is-disabled' : '') + (o.icon ? '' : ' lb__card--noicon') + '" role="button" tabindex="' + (o.disabled ? '-1' : '0') + '" aria-pressed="' + (o.selected ? 'true' : 'false') + '"' + (o.disabled ? ' aria-disabled="true"' : '') + (big ? ' data-photo="' + esc(big) + '"' : '') + (bigDark ? ' data-photo-dark="' + esc(bigDark) + '" data-dark-key="' + esc(photoKey(o.icon)) + '"' : '') + ' ' + o.attrs + '>' +
      (o.icon ? '<span class="lb__card-icon">' + cardIcon(o.icon) + '</span>' : '') +
      '<span class="lb__card-text"><span class="lb__card-title">' + esc(o.title) + (o.badge ? ' <span class="lb__badge' + (o.badgeWarn ? ' lb__badge--warn' : '') + '">' + esc(o.badge) + '</span>' : '') + '</span>' +
      (o.desc ? '<span class="lb__card-desc">' + esc(o.desc) + '</span>' : '') +
      infoBlock(o.info, o.includes) + (o.extra || '') + '</span>' +
      '<span class="lb__card-side">' + (o.price != null ? '<span class="lb__card-price">' + esc(o.price) + '</span>' : '') +
      (hasInfo ? '<button type="button" class="lb__info-btn" data-info aria-label="More about ' + esc(o.title) + '" aria-expanded="false">' + icon('info') + '</button>' : '') + '</span>' +
      '<span class="lb__radio" aria-hidden="true">' + icon('check', 'lb__radio-check') + '</span>' +
      (o.panel ? '<div class="lb__card-panel">' + o.panel + '</div>' : '') +
      '</div>';
  }

  function viewUsage() {
    var html = head('What will you use them for?', 'Choose the type of vision these glasses are for.');
    html += '<div class="lb__cards">';
    USAGE_ORDER.forEach(function (k) {
      if (k === '__multi') {
        var isMulti = !!(U() && U().multi);
        html += card({ attrs: 'data-multi aria-expanded="' + !!(S.multiOpen || isMulti) + '"', icon: 'multifocal', title: 'Multifocal', desc: 'Near and far in one lens: Progressive or Bifocal.', selected: isMulti });
        html += '<div class="lb__sub' + (S.multiOpen || isMulti ? ' is-open' : '') + '" data-multi-sub><div class="lb__sub-inner"><div class="lb__cards">' + ['progressive', 'bifocal'].map(function (m) {
          var u = USAGES[m];
          return card({ attrs: 'data-usage="' + m + '"', icon: u.icon, title: u.label, desc: u.desc, info: u.info, selected: S.usage === m });
        }).join('') + '</div></div></div>';
        return;
      }
      var u = USAGES[k];
      html += card({ attrs: 'data-usage="' + k + '"', icon: u.icon, title: u.label, desc: u.desc, info: u.info, selected: S.usage === k });
    });
    html += '</div><div class="lb__divider"><span>or</span></div><div class="lb__cards">';
    html += card({ attrs: 'data-usage="__frame_only"', icon: 'frame', title: 'Frame only', desc: 'Buy the frame without prescription lenses.', selected: S.usage === '__frame_only', muted: true });
    return html + '</div>';
  }

  function viewCategory() {
    var html = head('Choose a lens type', USAGES[S.usage].label + ' lenses');
    html += '<div class="lb__cards">';
    // no prices here: they show inside each lens type, together with the price note
    catsFor(S.usage).forEach(function (c) {
      html += card({ attrs: 'data-category="' + esc(c.key) + '"', icon: c.icon || c.key, title: catName(c), desc: c.description, selected: S.category === c.key });
    });
    return html + '</div>' + customNote();
  }

  // Distance only: says why prices are higher (high CYL) or that they depend on the power.
  function priceNote() {
    if (S.usage !== 'distance') return '';
    var f = cylFactor();
    if (f > 1) {
      return '<div class="lb__info lb__info--tip">' + icon('info') + '<p>Your cylinder (CYL) is ±' + maxCyl().toFixed(2) +
        ', so Distance lens prices are <strong>' + f + 'x</strong>. Prices below already include this.</p></div>';
    }
    if (!powerKnown()) {
      return '<div class="lb__info lb__info--tip">' + icon('info') + '<p>Lens prices vary by power. For cylinder (CYL) above ±2.50 lenses cost 1.5x, and above ±4.00 they cost 2x. ' +
        'Ultra Thin lenses are for powers of ±3.00 and above.</p></div>';
    }
    return '';
  }

  /* ---------- colour groups (tint, transition bifocal) ---------- */
  var STRENGTH_ALPHA = { Dark: 0.8, Medium: 0.5, Light: 0.2 };
  // The real lens photo with the tint laid over the lens: the colour multiplies the scene (like a tinted lens) and a
  // little grey takes the light down further, both at the tint strength, through a mask cut to the lens
  // (assets/lens-tint-*.{jpg,png}). Photo and mask scale together, so it fits any screen width.
  function tintLayers(color, alpha) {
    return 'background:' + esc(color) + ';opacity:' + alpha + '|opacity:' + (alpha * 0.3).toFixed(2);
  }
  function tintScene(color, alpha) {
    var st = tintLayers(color, alpha).split('|');
    var mask = D.tintMask ? 'url(' + D.tintMask + ')' : 'none';
    return '<div class="lb__tint" style="--lb-tint-mask:' + esc(mask) + '" role="img" aria-label="Tint preview">' +
      '<img class="lb__tint-photo" src="' + esc(D.tintPhoto || '') + '" alt="" width="1280" height="720" loading="lazy" decoding="async">' +
      '<span class="lb__tint-color" style="' + st[0] + '"></span><span class="lb__tint-shade" style="' + st[1] + '"></span></div>';
  }
  function swatchLabel(m) { return m.name.replace(/\s*tint$/i, ''); }
  function groupPanel(members, selMember) {
    var withStrength = members.some(function (m) { return m.strength; });
    var color = selMember ? selMember.swatch : members[0].swatch;
    var html = '<div class="lb__group" data-group-panel data-default="' + esc(members[0].swatch) + '">';
    if (withStrength) {
      html += '<div class="lb__preview" data-tint-art>' + tintScene(color, STRENGTH_ALPHA[S.strength] || 0.8) + '</div>';
    }
    html += '<div class="lb__group-label">Colour<span class="lb__group-value" data-colour-name>' + (selMember ? esc(swatchLabel(selMember)) : '') + '</span></div>';
    html += '<div class="lb__swatches" role="radiogroup" aria-label="Colour">' + members.map(function (m) {
      var on = selMember && selMember.idx === m.idx;
      return '<button type="button" class="lb__swatch' + (on ? ' is-selected' : '') + '" role="radio" aria-checked="' + !!on + '" data-swatch="' + m.idx + '" style="--sw:' + esc(m.swatch || '#999999') + '" aria-label="' + esc(swatchLabel(m)) + '">' +
        '<span class="lb__swatch-dot" aria-hidden="true"></span><span class="lb__swatch-text">' + esc(swatchLabel(m)) + '</span></button>';
    }).join('') + '</div>';
    if (withStrength) {
      html += '<div class="lb__group-label">Tint strength</div>';
      html += '<div class="lb__strengths" role="radiogroup" aria-label="Tint strength">' + STRENGTHS.map(function (s) {
        var on = S.strength === s[0];
        return '<button type="button" role="radio" aria-checked="' + on + '" class="lb__strength-btn' + (on ? ' is-selected' : '') + '" data-strength="' + s[0] + '">' +
          '<span class="lb__strength-dot" aria-hidden="true" style="background:' + esc(color) + ';opacity:' + STRENGTH_ALPHA[s[0]] + '"></span>' +
          '<span class="lb__strength-name">' + s[0] + '</span><span class="lb__strength-pct">' + s[1] + '</span></button>';
      }).join('') + '</div>';
      html += '<p class="lb__group-note">' + icon('info', 'lb__group-note-icon') + 'Dark tints are for daytime use and are not suitable for night driving.</p>';
    }
    return html + '</div>';
  }
  function refreshGroup(cardEl) {
    var panel = cardEl && cardEl.querySelector('[data-group-panel]');
    if (!panel) return;
    var sel = S.lens && S.lens.group === cardEl.dataset.group ? S.lens : null;
    var color = sel ? sel.swatch : panel.dataset.default;
    var a = STRENGTH_ALPHA[S.strength] || 0.8;
    var tc = panel.querySelector('.lb__tint-color'), ts = panel.querySelector('.lb__tint-shade');
    if (tc) { tc.style.background = color; tc.style.opacity = a; }
    if (ts) ts.style.opacity = (a * 0.3).toFixed(2);
    var cn = panel.querySelector('[data-colour-name]');
    if (cn) cn.textContent = sel ? swatchLabel(sel) : '';
    panel.querySelectorAll('.lb__strength-dot').forEach(function (d) { d.style.background = color; });
  }

  // Shown under every lens list: customers who need something not listed contact the store.
  function customNote() {
    var body = '<span class="lb__custom-badge">' + icon('chat', 'lb__custom-icon') + '</span>' +
      '<span class="lb__custom-text"><strong>Need customised lenses?</strong>' +
      '<small>Tell us your prescription and what you need, and our team will help you choose the right lenses.</small></span>';
    if (!D.whatsappLink) return '<div class="lb__custom">' + body + '<span class="lb__custom-cta">Contact us on WhatsApp</span></div>';
    return '<a class="lb__custom" href="' + esc(D.whatsappLink) + '" target="_blank" rel="noopener">' + body +
      '<span class="lb__custom-cta">Chat on WhatsApp <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></span></a>';
  }

  /* ---------- transition colour (Gray / Brown): asked once, above the lens list ---------- */
  var TRN_COLOURS = [['Gray', '#6b6e72'], ['Brown', '#7a5230']];
  function isTrn(l) { return /transition/i.test(l.key); }
  // bifocal transitions are separate Brown / Gray variants of one group: picked by the colour bar, no chips
  function isTrnGroup(members) { return members.length > 1 && members.every(function (m) { return isTrn(m) && /^(brown|gray|grey)$/i.test(m.name); }); }
  function trnMember(members) {
    return members.filter(function (m) { return m.name.toLowerCase() === S.trnColour.toLowerCase(); })[0] || members[0];
  }
  function trnBar() {
    return '<div class="lb__trn"><div class="lb__trn-text"><strong>Transition colour</strong><span>The colour the lenses turn in sunlight</span></div>' +
      '<div class="lb__strengths lb__trn-seg" role="radiogroup" aria-label="Transition colour">' + TRN_COLOURS.map(function (c) {
        var on = S.trnColour === c[0];
        return '<button type="button" role="radio" aria-checked="' + on + '" class="lb__strength-btn' + (on ? ' is-selected' : '') + '" data-trn="' + c[0] + '">' +
          '<span class="lb__strength-dot" aria-hidden="true" style="background:' + c[1] + '"></span><span class="lb__strength-name">' + c[0] + '</span></button>';
      }).join('') + '</div></div>';
  }
  function setTrnColour(c) {
    S.trnColour = c;
    host.querySelectorAll('[data-trn]').forEach(function (b) {
      var on = b.dataset.trn === c;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    host.querySelectorAll('img[data-dark-key]').forEach(function (img) { img.src = darkPhoto(img.dataset.darkKey); });
    host.querySelectorAll('.lb__card[data-dark-key]').forEach(function (el) { el.setAttribute('data-photo-dark', darkPhoto(el.dataset.darkKey, true)); });
    // a chosen bifocal transition follows the colour
    if (S.lens && S.lens.group && isTrn(S.lens)) {
      var members = lensesFor(S.usage, S.category).filter(function (x) { return x.group === S.lens.group; });
      if (isTrnGroup(members)) S.lens = trnMember(members);
    }
    renderStepper(); updateNav(); updateTotals();
  }

  function viewLens() {
    if (S.lens && lensHidden(S.lens)) S.lens = null;
    var list = lensesFor(S.usage, S.category);
    var cat = CATS.filter(function (c) { return c.key === S.category; })[0];
    var html = head('Choose your lenses', (cat ? catName(cat) + ' · ' : '') + USAGES[S.usage].label);
    html += priceNote();
    if (list.some(isTrn)) html += trnBar();
    html += '<div class="lb__cards">';
    var seen = {};
    list.forEach(function (l) {
      if (l.group) {
        if (seen[l.group]) return;
        seen[l.group] = 1;
        var members = list.filter(function (x) { return x.group === l.group; });
        var selMember = S.lens && S.lens.group === l.group ? S.lens : null;
        var prices = members.map(function (x) { return effVariant(x).price; });
        var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
        var trnGroup = isTrnGroup(members);
        var panel = trnGroup ? '' : groupPanel(members, selMember);
        html += card({ attrs: 'data-group="' + esc(l.group) + '"' + (trnGroup ? ' data-trn-group' : ''), icon: l.strength ? '' : (l.iconKey || catIcon(S.category)), title: l.group, desc: l.info, includes: l.includes, price: min === max ? (min ? '+ ' + shortMoney(min) : 'Free') : 'from ' + shortMoney(min), selected: !!selMember, panel: panel });
        return;
      }
      var blocked = lensBlocked(l);
      var price = effVariant(l).price;
      html += card({
        attrs: 'data-lens="' + l.idx + '"', icon: l.iconKey || catIcon(S.category), title: l.name,
        desc: blocked ? 'Not suitable above ±' + l.maxPower.toFixed(2) + '.' : l.info,
        includes: l.includes, price: price ? '+ ' + shortMoney(price) : 'Free',
        selected: S.lens && S.lens.idx === l.idx, disabled: blocked || !l.variant.available,
        badge: blocked ? 'Not suitable' : '', badgeWarn: blocked,
      });
    });
    return html + '</div>' + customNote();
  }

  function sel(name, values, value, placeholder, disabled) {
    var html = '<select class="lb__select" name="' + name + '" id="lb-' + name + '" data-field="' + name + '"' + (disabled ? ' disabled' : '') + ' aria-label="' + esc(name) + '">';
    html += '<option value="">' + esc(placeholder) + '</option>';
    values.forEach(function (v) {
      var val = typeof v === 'object' ? v.value : v;
      var label = typeof v === 'object' ? v.label : v;
      html += '<option value="' + esc(val) + '"' + (String(val) === String(value) ? ' selected' : '') + '>' + esc(label) + '</option>';
    });
    return html + '</select>';
  }
  function rxTable() {
    var contact = D.mode === 'contact';
    var cols = toric() ? 3 : 1;
    var sphList = (contact ? SPH_CONTACT : SPH_GLASSES).map(function (v) { return v === '0.00' ? { value: v, label: '0.00 (Plano)' } : v; });
    var html = '<div class="lb__rx lb__rx--' + cols + '">';
    html += '<div class="lb__rx-row lb__rx-row--head"><span></span><span>SPH</span>' + (cols === 3 ? '<span>CYL</span><span>Axis</span>' : '') + '</div>';
    [['r', 'OD', 'Right eye'], ['l', 'OS', 'Left eye']].forEach(function (p) {
      var k = p[0], eye = S.rx[k];
      var mirrored = contact && S.rx.same && k === 'l';
      var axisOff = !eye.cyl || eye.cyl === '0.00';
      html += '<div class="lb__rx-row' + (mirrored ? ' is-mirrored' : '') + '" data-eye="' + k + '">';
      html += '<span class="lb__rx-eye"><strong>' + p[1] + '</strong><small>' + p[2] + '</small></span>';
      html += sel('sph-' + k, sphList, eye.sph, 'Select', mirrored);
      if (cols === 3) {
        html += sel('cyl-' + k, contact ? CYL_CONTACT : CYL_GLASSES.map(function (v) { return v === '0.00' ? { value: v, label: 'None' } : v; }), eye.cyl, contact ? 'Select' : 'None', mirrored);
        html += sel('axis-' + k, contact ? AXIS_CONTACT : AXIS_GLASSES, axisOff ? '' : eye.axis, axisOff ? '–' : 'Select', mirrored || axisOff);
      }
      html += '</div>';
    });
    html += '</div>';
    if (!contact) html += '<div data-rx-hint>' + rxHint() + '</div>';
    if (contact) html += '<label class="lb__switch"><input type="checkbox" id="lb-same" data-same' + (S.rx.same ? ' checked' : '') + '><span class="lb__switch-ui" aria-hidden="true"></span><span>Same power for both eyes</span></label>';
    if (!contact && needsAdd()) {
      // Near vision is what makes a lens multifocal, so this field stands out.
      html += '<div class="lb__field-row lb__field-row--near"><div class="lb__field-label"><span class="lb__near-tag">' + icon('near', 'lb__near-icon') + 'Near vision</span>' +
        '<strong>ADD (near addition)</strong><small>Your reading power, written as ADD on your prescription. Same for both eyes.</small></div>' + sel('add', ADD_VALUES, S.rx.add, 'Select ADD') + '</div>';
    }
    html += pdBlock();
    html += '<div class="lb__attach"><div class="lb__field-label"><strong>Attach a photo of your prescription</strong><small>Optional, helps us double-check your values.</small></div>' + uploadBox() + '</div>';
    return html;
  }
  function rxHint() {
    if (isPlanoRx()) return '<p class="lb__hint lb__hint--warn">All values are 0.00 (no power). If you do not need power, choose Zero Power in step 1.</p>';
    if (bigDifference()) return '<p class="lb__hint lb__hint--warn">Your right and left SPH differ by more than 3.00. Please double-check the values.</p>';
    return '';
  }
  function pdBlock() {
    if (D.mode !== 'frame') return '';
    var html = '<div class="lb__pd"><div class="lb__field-label"><strong>Pupillary distance (PD)</strong><small>Distance between your pupils, in mm</small></div>';
    html += '<div class="lb__segmented" role="radiogroup" data-field="pdMode">' + [['single', 'One PD'], ['dual', 'Two PDs'], ['unknown', "I don't know"]].map(function (o) {
      var on = S.rx.pdMode === o[0];
      return '<button type="button" role="radio" aria-checked="' + on + '" class="' + (on ? 'is-selected' : '') + '" data-pd="' + o[0] + '">' + o[1] + '</button>';
    }).join('') + '</div>';
    if (needsAdd()) html += '<p class="lb__hint">For bifocal and progressive lenses, two PDs (right and left) give the most accurate fit.</p>';
    return html + '<div class="lb__pd-body" data-pd-body>' + pdBody() + '</div></div>';
  }
  function pdBody() {
    if (S.rx.pdMode === 'single') return '<div class="lb__pd-fields">' + sel('pd', PD_SINGLE, S.rx.pd, 'PD (mm)') + '</div>';
    if (S.rx.pdMode === 'dual') return '<div class="lb__pd-fields lb__pd-fields--2">' + sel('pdR', PD_DUAL, S.rx.pdR, 'Right PD') + sel('pdL', PD_DUAL, S.rx.pdL, 'Left PD') + '</div>';
    if (S.rx.pdMode === 'unknown') return '<p class="lb__hint">No problem. You can send your PD later with your order number.</p>';
    return '';
  }

  /* prescription photo */
  var MAX_FILE = 10 * 1024 * 1024;
  function fileSize(b) { return b > 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB'; }
  function uploadInner() {
    if (!S.file) {
      return '<label class="lb__drop" for="lb-file" data-drop>' + icon('upload') +
        '<span class="lb__drop-title">Choose a photo or PDF</span><span class="lb__drop-sub">or drag it here · JPG, PNG or PDF, up to 10 MB</span></label>';
    }
    var isImg = /^image\//.test(S.file.type);
    return '<div class="lb__file">' +
      (isImg ? '<img class="lb__file-thumb" src="' + S.filePreview + '" alt="">' : '<span class="lb__file-thumb lb__file-thumb--doc">' + icon('doc') + '</span>') +
      '<span class="lb__file-text"><strong>' + esc(S.file.name) + '</strong><small>' + fileSize(S.file.size) + '</small></span>' +
      '<label class="lb__file-btn" for="lb-file">Change</label>' +
      '<button type="button" class="lb__file-btn" data-file-remove>Remove</button></div>';
  }
  function uploadBox() {
    return '<div class="lb__upload" data-field="file"><input type="file" id="lb-file" class="lb__file-input" accept="image/*,application/pdf" data-file>' +
      '<div data-upload-inner>' + uploadInner() + '</div></div>';
  }
  function setFile(f) {
    if (f && !(/^image\//.test(f.type) || f.type === 'application/pdf')) { showError('Please choose a photo (JPG, PNG) or a PDF.'); return; }
    if (f && f.size > MAX_FILE) { showError('This file is larger than 10 MB. Please choose a smaller photo.'); return; }
    if (S.filePreview) URL.revokeObjectURL(S.filePreview);
    S.file = f || null;
    S.filePreview = f && /^image\//.test(f.type) ? URL.createObjectURL(f) : '';
    var box = host.querySelector('[data-field="file"]');
    if (box) box.classList.remove('is-invalid');
    swapBody(host.querySelector('[data-upload-inner]'), uploadInner());
    if (rxErrors().length === 0) hideError();
    updateNav();
  }

  function rxBody() {
    if (S.rxMethod === 'enter') return rxTable();
    if (S.rxMethod === 'upload') return '<div class="lb__attach lb__attach--main">' + uploadBox() + '<p class="lb__hint">Make sure all values on the prescription are clearly readable.</p></div>' + pdBlock();
    if (S.rxMethod === 'reader') {
      return '<div class="lb__field-row"><div class="lb__field-label"><strong>Reading power</strong><small>Same power for both eyes, e.g. +1.50</small></div>' + sel('reader', READER_VALUES, S.rx.reader, 'Select power') + '</div>' + pdBlock();
    }
    if (S.rxMethod === 'later') {
      return '<div class="lb__info">' + icon('clock') + '<p>After placing your order, send a clear photo of your prescription' +
        (D.whatsapp ? ' on WhatsApp to <strong>' + esc(D.whatsapp) + '</strong>'
          : D.whatsappLink ? ' on <a href="' + esc(D.whatsappLink) + '" target="_blank" rel="noopener">WhatsApp</a>' : '') + ' with your order number' +
        (D.mode === 'frame' ? ', including your PD if you have it' : '') + '.</p></div>';
    }
    if (S.rxMethod === 'none') return '<div class="lb__info">' + icon('none') + '<p>Lenses without power (0.00) for both eyes.</p></div>';
    return '';
  }
  function viewRx() {
    var contact = D.mode === 'contact';
    var html = contact
      ? head('Your eye power', D.isToric ? 'Toric lens: SPH, CYL and Axis are needed for each eye.' : 'Choose the power for each eye.')
      : head('Add your prescription', USAGES[S.usage].label + ' · use the values written on your prescription.');
    var methods = [{ v: 'upload', icon: 'upload', t: 'Upload a photo', d: 'A photo or PDF of your prescription.' }];
    methods.push({ v: 'enter', icon: 'pencil', t: contact ? 'Enter my power' : 'Enter it now', d: contact ? 'Choose the power for each eye.' : 'Fill in the values from your prescription.' });
    if (!contact && S.usage === 'reading') methods.push({ v: 'reader', icon: 'reading', t: 'Reading power only', d: 'One power for both eyes, like ready-made readers.' });
    if (contact && !D.isToric) methods.push({ v: 'none', icon: 'none', t: 'No power', d: 'Cosmetic lenses, 0.00 for both eyes.' });
    methods.push({ v: 'later', icon: 'clock', t: 'Send it after ordering', d: 'Share a photo of your prescription after checkout.' });
    html += '<div class="lb__cards lb__cards--methods">' + methods.map(function (m) {
      return card({ attrs: 'data-method="' + m.v + '"', icon: m.icon, title: m.t, desc: m.d, selected: S.rxMethod === m.v });
    }).join('') + '</div>';
    return html + '<div class="lb__rx-body" data-rx-body>' + rxBody() + '</div>';
  }

  function eyeText(k) {
    var eye = S.rx[k];
    var parts = ['SPH ' + eye.sph];
    if (toric()) {
      if (eye.cyl && eye.cyl !== '0.00') parts.push('CYL ' + eye.cyl, 'Axis ' + eye.axis);
      else parts.push('CYL None');
    }
    return parts.join(' · ');
  }
  function syncSame() { if (D.mode === 'contact' && S.rx.same) S.rx.l = { sph: S.rx.r.sph, cyl: S.rx.r.cyl, axis: S.rx.r.axis }; }
  function pdLine() {
    if (S.rx.pdMode === 'single') return ['PD', S.rx.pd + ' mm'];
    if (S.rx.pdMode === 'dual') return ['PD', 'R ' + S.rx.pdR + ' · L ' + S.rx.pdL + ' mm'];
    if (S.rx.pdMode === 'unknown') return ['PD', 'Will send later'];
    return null;
  }
  function rxLines() {
    if (D.mode === 'contact') {
      if (S.rxMethod === 'none') return [['Power', 'No power (0.00)']];
      if (S.rxMethod === 'later') return [['Power', 'Will send prescription after ordering']];
      if (S.rxMethod === 'upload') return [['Power', 'From uploaded prescription']];
      syncSame();
      return [['Power', 'Entered online'], ['Right eye (OD)', eyeText('r')], ['Left eye (OS)', eyeText('l')]];
    }
    if (!needsRx()) return [['Prescription', 'Not needed']];
    if (S.rxMethod === 'later') return [['Prescription', 'Will send after ordering']];
    var lines;
    if (S.rxMethod === 'upload') lines = [['Prescription', 'Uploaded photo']];
    else if (S.rxMethod === 'reader') lines = [['Prescription', 'Reading power ' + S.rx.reader + ' (both eyes)']];
    else {
      lines = [['Prescription', 'Entered online'], ['Right eye (OD)', eyeText('r')], ['Left eye (OS)', eyeText('l')]];
      if (needsAdd()) lines.push(['ADD', S.rx.add]);
    }
    var pd = pdLine();
    if (pd) lines.push(pd);
    return lines;
  }
  function lensLines() {
    if (!S.lens) return [];
    var cat = CATS.filter(function (c) { return c.key === S.lens.category; })[0];
    var lensName = S.lens.group ? S.lens.group + ' – ' + S.lens.name : S.lens.name;
    var typeName = cat ? catName(cat) : S.lens.category;
    var lines = [['Usage', USAGES[S.usage].label]];
    if (typeName.toLowerCase() !== lensName.toLowerCase()) lines.push(['Lens type', typeName]);
    lines.push(['Lens', lensName]);
    if (isTrn(S.lens) && !S.lens.group) lines.push(['Transition colour', S.trnColour]);
    if (S.lens.strength) lines.push(['Tint strength', S.strength + ' (' + STRENGTHS.filter(function (s) { return s[0] === S.strength; })[0][1] + ')']);
    if (cylFactor() > 1) lines.push(['Price', cylFactor() + 'x for cylinder above ±' + (cylFactor() === 2 ? '4.00' : '2.50')]);
    return lines;
  }

  function viewReview() {
    var html = head('Review your order', 'Check your choices before adding to cart.');
    var keys = steps().map(function (s) { return s.key; });
    function editFor(key) {
      var i = keys.indexOf(key);
      return i > -1 ? '<button type="button" class="lb__edit" data-goto="' + i + '">Edit</button>' : '';
    }
    function list(lines) { return '<dl class="lb__review-list">' + lines.map(function (l) { return '<div><dt>' + esc(l[0]) + '</dt><dd>' + esc(l[1]) + '</dd></div>'; }).join('') + '</dl>'; }
    var frameName = D.product.title + (D.variant.title && D.variant.title !== 'Default Title' ? ' – ' + D.variant.title : '');
    html += '<div class="lb__review">';
    html += '<div class="lb__review-card"><div class="lb__review-top"><span>' + (D.mode === 'contact' ? 'Contact lenses' : 'Frame') + '</span></div><p>' + esc(frameName) + '</p></div>';
    if (D.mode === 'frame') {
      if (S.usage === '__frame_only') html += '<div class="lb__review-card"><div class="lb__review-top"><span>Lenses</span>' + editFor('usage') + '</div><p>Frame only</p></div>';
      else html += '<div class="lb__review-card"><div class="lb__review-top"><span>Lenses</span>' + editFor(keys.indexOf('lens') > -1 ? 'lens' : 'category') + '</div>' + list(lensLines()) + '</div>';
    }
    if (D.mode === 'contact' || S.usage !== '__frame_only') {
      var lines = rxLines();
      if (sendsFile()) lines = lines.concat([['Photo', S.file.name]]);
      html += '<div class="lb__review-card"><div class="lb__review-top"><span>' + (D.mode === 'contact' ? 'Power' : 'Prescription') + '</span>' + editFor(D.mode === 'contact' ? 'power' : needsRx() ? 'rx' : 'usage') + '</div>' + list(lines) + '</div>';
    }
    if (!D.variant.available) html += '<div class="lb__info"><p>This item is sold out.</p></div>';
    return html + '</div>';
  }

  function viewFor(key) {
    if (key === 'usage') return viewUsage();
    if (key === 'rx' || key === 'power') return viewRx();
    if (key === 'category') return viewCategory();
    if (key === 'lens') return viewLens();
    return viewReview();
  }

  /* ---------- render + transitions ---------- */
  /* ---------- info popover (one floating element, positioned next to the ⓘ button) ---------- */
  var pop = document.createElement('div');
  pop.className = 'lb__pop';
  pop.setAttribute('role', 'dialog');
  pop.hidden = true;
  pop.innerHTML = '<button type="button" class="lb__pop-close" aria-label="Close">&times;</button><div class="lb__pop-title"></div><div class="lb__pop-body"></div>';
  document.body.appendChild(pop);
  var popFor = null;
  function closePop() {
    if (!popFor) return;
    popFor.setAttribute('aria-expanded', 'false');
    popFor.classList.remove('is-open');
    popFor = null;
    pop.classList.remove('is-visible');
    pop.hidden = true;
  }
  function placePop(btn) {
    var r = btn.getBoundingClientRect();
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var w = Math.min(pop.querySelector('.lb__pop-img') ? 340 : 300, vw - 24);
    pop.style.width = w + 'px';
    var left = Math.max(12, Math.min(r.right - w + 8, vw - w - 12));
    var top = r.bottom + 8;
    var h = pop.offsetHeight;
    var above = top + h > vh - 90 && r.top - h - 8 > 12;
    pop.classList.toggle('is-above', above);
    pop.style.left = left + 'px';
    pop.style.top = (above ? r.top - h - 8 : top) + 'px';
    pop.style.setProperty('--arrow-x', Math.max(14, Math.min(w - 14, r.left + r.width / 2 - left)) + 'px');
  }
  function togglePop(btn) {
    if (popFor === btn) { closePop(); return; }
    closePop();
    var card = btn.closest('.lb__card');
    var more = card && card.querySelector('.lb__more');
    if (!more) return;
    pop.querySelector('.lb__pop-title').textContent = card.querySelector('.lb__card-title').childNodes[0].textContent.trim();
    var photo = card.getAttribute('data-photo'), photoDark = card.getAttribute('data-photo-dark');
    pop.querySelector('.lb__pop-body').innerHTML = (photo ? '<span class="lb__pop-photo"><img class="lb__pop-img" src="' + esc(photo) + '" alt="" width="720" height="540" decoding="async">' +
      (photoDark ? '<img class="lb__pop-img lb__photo-dark" src="' + esc(photoDark) + '" alt="" width="720" height="540" decoding="async">' : '') + '</span>' : '') + more.innerHTML;
    pop.hidden = false;
    placePop(btn);
    requestAnimationFrame(function () { if (!pop.hidden) pop.classList.add('is-visible'); });
    popFor = btn;
    popAnchor = { y: window.pageYOffset, vy: viewport.scrollTop, w: document.documentElement.clientWidth };
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-open');
  }
  pop.querySelector('.lb__pop-close').addEventListener('click', closePop);
  document.addEventListener('click', function (e) { if (popFor && !pop.contains(e.target) && !e.target.closest('[data-info]')) closePop(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
  // Close only on a real scroll or width change: small scrolls and mobile
  // address-bar resizes would otherwise close it right after opening.
  var popAnchor = { y: 0, vy: 0, w: 0 };
  function maybeClose() {
    if (!popFor) return;
    if (Math.abs(window.pageYOffset - popAnchor.y) > 40 || Math.abs(viewport.scrollTop - popAnchor.vy) > 40) closePop();
    else placePop(popFor);
  }
  window.addEventListener('scroll', maybeClose, { passive: true });
  viewport.addEventListener('scroll', maybeClose, { passive: true });
  window.addEventListener('resize', function () {
    if (!popFor) return;
    if (document.documentElement.clientWidth !== popAnchor.w) closePop(); else placePop(popFor);
  });

  function paint() {
    closePop();
    host.innerHTML = viewFor(current().key);
    host.setAttribute('data-step', current().key);
    renderStepper();
    updateNav();
    updateTotals();
    hideError();
    if (S.showErrors) markErrors();
  }
  function scrollTop() {
    if (isDesktop()) viewport.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
    else {
      var y = panel.getBoundingClientRect().top + window.pageYOffset - 8;
      if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: REDUCED ? 'auto' : 'smooth' });
    }
  }
  function goTo(index) {
    var list = steps();
    if (index < 0 || index >= list.length || index === S.step || S.busy) return Promise.resolve();
    var dir = index > S.step ? 'fwd' : 'back';
    S.showErrors = false;
    if (REDUCED) { S.step = index; paint(); scrollTop(); return Promise.resolve(); }
    S.busy = true;
    host.classList.add('is-out', 'is-' + dir);
    return wait(170).then(function () {
      S.step = index;
      paint();
      host.classList.remove('is-out');
      host.classList.add('is-in');
      void host.offsetWidth;
      host.classList.remove('is-in');
      scrollTop();
      return wait(260);
    }).then(function () {
      host.classList.remove('is-fwd', 'is-back');
      S.busy = false;
    });
  }
  function advance() {
    S.busy = true;
    return wait(REDUCED ? 0 : 280).then(function () { S.busy = false; return goTo(S.step + 1); });
  }
  function swapBody(container, html) {
    if (!container) return;
    if (REDUCED) { container.innerHTML = html; return; }
    container.classList.add('is-swapping');
    setTimeout(function () { container.innerHTML = html; void container.offsetWidth; container.classList.remove('is-swapping'); }, 140);
  }
  function selectCard(el) {
    Array.prototype.forEach.call(el.parentElement.children, function (c) {
      if (!c.classList.contains('lb__card')) return;
      var on = c === el;
      c.classList.toggle('is-selected', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- errors ---------- */
  function hideError() { errorEl.hidden = true; errorEl.textContent = ''; }
  function markErrors() {
    host.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
    var errs = rxErrors();
    errs.forEach(function (e) {
      if (e.field === 'method') host.querySelectorAll('[data-method]').forEach(function (c) { c.classList.add('is-invalid'); });
      else { var el = host.querySelector('[data-field="' + e.field + '"]'); if (el) el.classList.add('is-invalid'); }
    });
    return errs;
  }
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    errorEl.classList.remove('is-shake'); void errorEl.offsetWidth; errorEl.classList.add('is-shake');
  }

  /* ---------- events ---------- */
  function pickUsage(nu) {
    if (S.usage !== nu) {
      S.usage = nu;
      S.category = null;
      S.lens = null;
      if (S.rxMethod === 'reader' && nu !== 'reading') S.rxMethod = null;
    }
    host.querySelectorAll('[data-usage], [data-multi]').forEach(function (c) {
      var on = c.dataset.usage === nu || (c.hasAttribute('data-multi') && !!(USAGES[nu] && USAGES[nu].multi));
      c.classList.toggle('is-selected', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var cats = nu !== '__frame_only' ? catsFor(nu) : [];
    if (cats.length === 1) S.category = cats[0].key;
    pickOnlyLens();
    renderStepper(); updateNav(); updateTotals();
    advance();
  }
  function onActivate(e) {
    if (S.busy) return;
    if (!D.variant.available && !e.target.closest('a')) return;
    var infoBtn = e.target.closest('[data-info]');
    if (infoBtn) { e.stopPropagation(); togglePop(infoBtn); return; }
    var goto = e.target.closest('[data-goto]');
    if (goto) { goTo(Number(goto.dataset.goto)); return; }
    var trn = e.target.closest('[data-trn]');
    if (trn) { if (trn.dataset.trn !== S.trnColour) setTrnColour(trn.dataset.trn); return; }

    var st = e.target.closest('[data-strength]');
    if (st) {
      S.strength = st.dataset.strength;
      st.parentElement.querySelectorAll('[data-strength]').forEach(function (b) {
        var on = b === st;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      refreshGroup(st.closest('.lb__card'));
      return;
    }
    var swatch = e.target.closest('[data-swatch]');
    if (swatch) {
      S.lens = LENSES[Number(swatch.dataset.swatch)];
      var cardEl = swatch.closest('.lb__card');
      selectCard(cardEl);
      cardEl.querySelectorAll('[data-swatch]').forEach(function (b) {
        var on = b === swatch;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      refreshGroup(cardEl);
      renderStepper(); updateNav(); updateTotals(); hideError();
      return;
    }
    if (e.target.closest('[data-multi]')) {
      S.multiOpen = !S.multiOpen;
      var sub = host.querySelector('[data-multi-sub]');
      if (sub) sub.classList.toggle('is-open', S.multiOpen || !!(U() && U().multi));
      return;
    }
    var u = e.target.closest('[data-usage]');
    if (u) { pickUsage(u.dataset.usage); return; }

    var c = e.target.closest('[data-category]');
    if (c) {
      if (S.category !== c.dataset.category) { S.category = c.dataset.category; S.lens = null; }
      pickOnlyLens();
      selectCard(c);
      renderStepper(); updateNav(); updateTotals();
      advance();
      return;
    }
    // empty space inside the colour panel (preview, labels) is not a selection
    if (e.target.closest('[data-group-panel]')) return;
    var grp = e.target.closest('[data-group]');
    if (grp && grp.hasAttribute('data-trn-group')) {
      S.lens = trnMember(lensesFor(S.usage, S.category).filter(function (x) { return x.group === grp.dataset.group; }));
      selectCard(grp);
      renderStepper(); updateNav(); updateTotals();
      advance();
      return;
    }
    if (grp) {
      // tapping the card body picks the first colour when none is chosen yet
      if (!(S.lens && S.lens.group === grp.dataset.group)) {
        var first = grp.querySelector('[data-swatch]');
        if (first) first.click();
      }
      return;
    }
    var l = e.target.closest('[data-lens]');
    if (l) {
      if (l.classList.contains('is-disabled')) return;
      S.lens = LENSES[Number(l.dataset.lens)];
      selectCard(l);
      renderStepper(); updateNav(); updateTotals();
      advance();
      return;
    }
    var m = e.target.closest('[data-method]');
    if (m) {
      if (S.rxMethod !== m.dataset.method) {
        S.rxMethod = m.dataset.method;
        selectCard(m);
        swapBody(host.querySelector('[data-rx-body]'), rxBody());
      }
      S.showErrors = false; hideError();
      host.querySelectorAll('[data-method]').forEach(function (x) { x.classList.remove('is-invalid'); });
      updateNav();
      // "Send it after ordering" needs nothing else on this step: move on like the other card steps,
      // after a short pause so the WhatsApp note below the cards can be read
      clearTimeout(S.laterTimer);
      if (S.rxMethod === 'later') {
        var stepNow = S.step;
        S.laterTimer = setTimeout(function () {
          if (S.rxMethod === 'later' && S.step === stepNow && !S.busy) advance();
        }, REDUCED ? 600 : 1200);
      }
      return;
    }
    if (e.target.closest('[data-file-remove]')) { setFile(null); return; }
    var pd = e.target.closest('[data-pd]');
    if (pd) {
      S.rx.pdMode = pd.dataset.pd;
      pd.parentElement.querySelectorAll('[data-pd]').forEach(function (b) {
        var on = b === pd;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      pd.parentElement.classList.remove('is-invalid');
      swapBody(host.querySelector('[data-pd-body]'), pdBody());
      updateNav();
    }
  }
  host.addEventListener('click', onActivate);
  host.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.lb__card[role="button"]')) { e.preventDefault(); onActivate(e); }
  });
  stepper.addEventListener('click', function (e) {
    var b = e.target.closest('[data-goto]');
    if (b && !b.disabled) goTo(Number(b.dataset.goto));
  });

  ['dragenter', 'dragover'].forEach(function (t) {
    host.addEventListener(t, function (e) {
      var z = e.target.closest('[data-drop]');
      if (!z) return;
      e.preventDefault();
      z.classList.add('is-over');
    });
  });
  host.addEventListener('dragleave', function (e) {
    var z = e.target.closest('[data-drop]');
    if (z && !z.contains(e.relatedTarget)) z.classList.remove('is-over');
  });
  host.addEventListener('drop', function (e) {
    var z = e.target.closest('[data-drop]');
    if (!z) return;
    e.preventDefault();
    z.classList.remove('is-over');
    if (e.dataTransfer && e.dataTransfer.files[0]) setFile(e.dataTransfer.files[0]);
  });

  host.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches('[data-file]')) { if (el.files && el.files[0]) setFile(el.files[0]); el.value = ''; return; }
    if (el.matches('[data-same]')) {
      S.rx.same = el.checked;
      if (!S.rx.same) S.rx.l = { sph: '', cyl: '', axis: '' };
      syncSame();
      swapBody(host.querySelector('[data-rx-body]'), rxBody());
      updateNav();
      return;
    }
    el.classList.remove('is-invalid');
    var m = el.name && el.name.match(/^(sph|cyl|axis)-(r|l)$/);
    if (m) {
      S.rx[m[2]][m[1]] = el.value;
      if (m[1] === 'cyl') {
        var axis = host.querySelector('select[name="axis-' + m[2] + '"]');
        var off = !el.value || el.value === '0.00';
        if (off) S.rx[m[2]].axis = '';
        if (axis) {
          axis.disabled = off;
          axis.options[0].textContent = off ? '–' : 'Select';
          if (off) axis.value = '';
          axis.classList.remove('is-invalid');
        }
      }
      if (D.mode === 'contact' && S.rx.same && m[2] === 'r') {
        syncSame();
        ['sph', 'cyl', 'axis'].forEach(function (f) { var mirror = host.querySelector('select[name="' + f + '-l"]'); if (mirror) mirror.value = S.rx.l[f]; });
      }
    } else if (['add', 'reader', 'pd', 'pdR', 'pdL'].indexOf(el.name) !== -1) {
      S.rx[el.name] = el.value;
    }
    var hint = host.querySelector('[data-rx-hint]');
    if (hint) { var h = rxHint(); if (hint.innerHTML !== h) hint.innerHTML = h; }
    if (rxErrors().length === 0) hideError();
    updateNav();
  });

  prevBtn.addEventListener('click', function () { goTo(S.step - 1); });
  nextBtn.addEventListener('click', function () {
    if (S.busy) return;
    var key = current().key;
    if (!stepValid(key)) {
      if (key === 'rx' || key === 'power') {
        S.showErrors = true;
        var errs = markErrors();
        showError(errs[0].field === 'method' ? errs[0].msg : 'Please complete: ' + errs.map(function (x) { return x.msg; }).join(', ') + '.');
        var first = host.querySelector('.is-invalid');
        if (first) first.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
      } else {
        showError({ usage: 'Please choose what the glasses are for.', category: 'Please choose a lens type.', lens: S.lens && lensBlocked(S.lens) ? 'This lens is not suitable for your prescription.' : 'Please choose your lenses.' }[key] || 'Please make a selection.');
      }
      return;
    }
    if (key === 'review') addToCart();
    else goTo(S.step + 1);
  });

  /* ---------- add to cart ---------- */
  function addToCart() {
    nextBtn.disabled = true;
    nextBtn.classList.add('is-loading');
    nextLabel.textContent = 'Adding…';
    var items = [];
    var frameName = D.product.title + (D.variant.title && D.variant.title !== 'Default Title' ? ' – ' + D.variant.title : '');
    if (D.mode === 'contact') {
      var props = {};
      rxLines().forEach(function (l) { props[l[0]] = l[1]; });
      items.push({ id: D.variant.id, quantity: 1, properties: props });
    } else if (S.usage === '__frame_only') {
      items.push({ id: D.variant.id, quantity: 1 });
    } else {
      var setId = 'L' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var lensProps = { 'For frame': frameName };
      // the variant title already shows 'Lens Type' + 'Package' on the cart line
      lensLines().forEach(function (l) { if (l[0] !== 'Lens type' && l[0] !== 'Lens') lensProps[l[0]] = l[1]; });
      rxLines().forEach(function (l) { lensProps[l[0]] = l[1]; });
      lensProps._lens_set = setId;
      var label = (S.lens.group ? S.lens.group + ' – ' + S.lens.name : S.lens.name) + (S.lens.strength ? ' (' + S.strength + ')' : '') +
        (isTrn(S.lens) && !S.lens.group ? ' (' + S.trnColour + ')' : '');
      // Shopify lists the last item of a multi-item add first, so the lens goes
      // first in the request and the frame shows above it in the cart.
      items.push({ id: effVariant(S.lens).id, quantity: 1, properties: lensProps });
      items.push({ id: D.variant.id, quantity: 1, properties: { Lenses: USAGES[S.usage].label + ' – ' + label, _lens_set: setId } });
    }
    var withFile = sendsFile();
    var addedKey = null;
    function send(body, isForm) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body,
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.');
          return j;
        });
      });
    }
    function asForm(item) {
      var fd = new FormData();
      fd.append('id', item.id);
      fd.append('quantity', item.quantity);
      Object.keys(item.properties || {}).forEach(function (k) { fd.append('properties[' + k + ']', item.properties[k]); });
      fd.append('properties[Prescription photo]', S.file, S.file.name);
      return fd;
    }
    var run;
    if (!withFile) run = send(JSON.stringify({ items: items }), false);
    else {
      nextLabel.textContent = 'Uploading…';
      run = send(asForm(items[0]), true).then(function (j) {
        addedKey = j.key;
        return items.length > 1 ? send(JSON.stringify({ items: items.slice(1) }), false) : j;
      }).catch(function (err) {
        if (addedKey) {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: addedKey, quantity: 0 }) })
            .then(function () { throw err; });
        }
        throw err;
      });
    }
    run
      .then(function () { window.location.href = D.cartUrl || '/cart'; })
      .catch(function (err) {
        showError(err.message);
        nextBtn.disabled = false;
        nextBtn.classList.remove('is-loading');
        nextLabel.textContent = 'Add to cart';
      });
  }

  // Coming back with the browser Back button restores this page from the
  // back/forward cache with the button still in its "Adding…" state.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    S.busy = false;
    nextBtn.disabled = false;
    nextBtn.classList.remove('is-loading');
    host.classList.remove('is-out', 'is-in', 'is-fwd', 'is-back');
    paint();
  });

  if (D.mode === 'frame' && !LENSES.length) {
    host.innerHTML = '<div class="lb__info"><p>Lens options are not set up yet.</p></div>';
    return;
  }
  paint();
})();
